<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import UiStatusPill from '@/Components/UI/UiStatusPill.vue'

const props = defineProps({
  status: { type: String, required: true },
  overdue: { type: Boolean, default: false },
})
const { t } = useI18n()

const resolved = computed(() => {
  const s = props.status === 'active' && props.overdue ? 'overdue' : props.status
  return {
    pending:   { tone: 'warn',   variant: 'soft',    icon: 'clock', key: 'pending' },
    active:    { tone: 'ok',     variant: 'soft',    icon: '',      key: 'active' },
    overdue:   { tone: 'danger', variant: 'solid',   icon: 'alert', key: 'overdue' },
    extended:  { tone: 'info',   variant: 'outline', icon: '',      key: 'extended' },
    returned:  { tone: 'info',   variant: 'soft',    icon: 'check', key: 'returned' },
    cancelled: { tone: 'muted',  variant: 'outline', icon: '',      key: 'cancelled', strike: true },
  }[s] || { tone: 'muted', variant: 'soft', icon: '', key: s, strike: false }
})
</script>

<template>
  <UiStatusPill
    :tone="resolved.tone"
    :variant="resolved.variant"
    :icon="resolved.icon"
    :label="t(`rental.status.${resolved.key}`, resolved.key)"
    :strike="resolved.strike || false"
  />
</template>
